import { DeviceSelectionCategoryCoCo } from '../enums.js';

const CORE_DEVICE_CATEGORIES = new Set<string>([
  DeviceSelectionCategoryCoCo.PHONES,
  DeviceSelectionCategoryCoCo.TABLETS,
  DeviceSelectionCategoryCoCo.COMPUTERS,
]);

export const isCoreDeviceCategory = (category?: string): boolean =>
  category !== undefined && CORE_DEVICE_CATEGORIES.has(category);
